import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Translation from '@s/Translation';
import { getXssFilter } from '@showclix-shared-util/xssFilter';

const size = {
  small: "event-info--small",
  large: "event-info--large",
  largeLeft: "event-info--large-left",
}

/**
 * TODO - translate
 */
export default class Event extends Component {

    state = {
        descriptionCollapsed: true,
    }

    getDescription = () => {
      return this.props.description
        ? getXssFilter().process(this.props.description)
        : null;
    }

    renderDescription = () => {
      // strip tags from description
      const description = this.getDescription();
      if(description && (!this.props.collapseDescription || !this.state.descriptionCollapsed)){
        return (
            <div
              className="event-info__description"
              style={{whiteSpace: 'pre-wrap'}}
              dangerouslySetInnerHTML={{
                __html: description
              }}
            />
        )
      }
    }

    // TODO implement largeLeft image size for kiosk upsell
    render() {
        // strip tags from description
        const description = this.getDescription();

        return (
          <>
            <div className={`event-info ${this.props.size}`}>
                    {this.props.image &&
                        <div className="event-info__image">
                          <img src={this.props.image} />
                        </div>
                    }
                <div className="event-info__title-container">
                    {!!this.props.name && <h4 className="event-info__title">
                      {this.props.name}
                    </h4>}
                    {(!!this.props.date && !this.props.isSeries && !this.props.hideDate) &&
                      <div className="event-info__date">{this.props.date}</div>
                    }
                    {(!!this.props.isSeries && !this.props.hideDate) &&
                      <div className="event-info__date"><Translation>{'checkout__multiple_dates'}</Translation></div>
                    }
                    {!!this.props.venue && <div className="event-info__venue">
                      {this.props.venue}
                    </div>}
                    {!this.props.hideAgeLimit && !!this.props.venue && (
                      <div className="event-info__ages">
                        <Translation>{this.props.ages}</Translation>
                      </div>
                    )}
                    {(!!description && !!this.props.collapseDescription && !!this.state.descriptionCollapsed) && (
                        <a className="event-info__description-toggle" href="javascript:void(0)" onClick={() => {this.setState({descriptionCollapsed: false})}}><Translation>{'checkout__more_details'}</Translation></a>
                    )}
                    {(!!description && !!this.props.collapseDescription && !this.state.descriptionCollapsed) && (
                        <a className="event-info__description-toggle" href="javascript:void(0)" onClick={() => {this.setState({descriptionCollapsed: true})}}><Translation>{'checkout__less_details'}</Translation></a>
                    )}
                    {(this.props.size === Event.size.large || this.props.size === Event.size.largeLeft) && this.renderDescription()}
                </div>
            </div>
            {(this.props.size === Event.size.small) &&
              <div className="event-info-small__description">
                {this.renderDescription()}
              </div>
            }
            {this.props.underDescription}
          </>
        );
    }
}
Event.size = size;

Event.propTypes = {
  size: PropTypes.oneOf(Object.values(size)),
  image: PropTypes.any,
  name: PropTypes.any,
  date: PropTypes.any,
  venue: PropTypes.any,
  description: PropTypes.any,
  collapseDescription: PropTypes.bool,
  isSeries: PropTypes.bool,
  hideDate: PropTypes.bool,
  ages: PropTypes.string
}

Event.defaultProps = {
  size: Event.size.small,
  collapseDescription: false,
}
